import { z } from "@core/zod";

import { TextContentSchema } from "./text.ts";

export const RevisionContentSchema = z.discriminatedUnion("kind", [
  TextContentSchema,
]);
